WB.DataServices = WB.DataServices || {};

WB.DataServices.Popup = function ($http, $q) {

    this.GetPopupByTypeAndId = function(options) {
        return $q(function(resolve, reject) {
            $http({
                url: '/api/popups',
                method: 'GET',
                params: {
                    type: options.type,
                    id: options.id
                }
            })
                .success(function(popuData) {
                    resolve(popuData);
                })
                .error(function(data) {
                    reject(new Error('Unable to get popup.'));
                });
        });
    };

};
WB.DataServices.Popup.$inject = ['$http', '$q'];

WB.Core.service('PopupDataService', WB.DataServices.Popup);
